import React from "react"
import styled, { css } from "styled-components"
import { mixins, StyledForm } from "Styles"
import { theme } from "Theme"
import { Recaptcha, StyledSelect, Spacer, Input, TextArea, Heading } from "Components/FormElements"

export class BasicInfo extends React.Component {
  render() {
    const { disabled, onClick, last, onloadCallback, verifyCallback } = this.props

    return (
      <StyledForm>
        <Input
          name="firstName"
          label="First Name"
          placeholder="First Name"
          type="text"
          className="firsthalfWidthElement"
          required={true}
        />
        <Input
          name="lastName"
          label="Last Name"
          placeholder="Last Name"
          type="text"
          className="lasthalfWidthElement"
          required={true}
        />
        <Input
          name="title"
          label="Title"
          placeholder="Title"
          type="text"
          className="firsthalfWidthElement"
          required={true}
        />
        <Input
          name="company"
          label="Company"
          placeholder="Company"
          type="text"
          className="lasthalfWidthElement"
          required={true}
        />
        <Input
          name="phone"
          label="Phone"
          placeholder="Your phone number"
          className="firsthalfWidthElement"
          type="tel"
          required={true}
        />
        <Input
          name="email"
          label="Email (Corporate Only)"
          placeholder="Your email"
          className="lasthalfWidthElement"
          type="email"
          required={true}
        />
        <TextArea
          name="message"
          label="More Details"
          placeholder="Add notes here"
          type="text"
          className="messageElement"
        />

        {/* <div className="fullWidthElement">
          <Recaptcha name="Recaptcha" onloadCallback={onloadCallback} verifyCallback={verifyCallback} />
        </div> */}

        <div className="buttonsWrapper">
          <button type="button" className="btn" onClick={this.props.previousStep} data-gtm={`Form Sponsor | Back`}>
            Back
          </button>
          {!last && (
            <button type="button" className="btn" onClick={this.props.nextStep} data-gtm={`Form Sponsor | Next`}>
              Next
            </button>
          )}
          {last && (
            <button type="submit" className="btn" disabled={disabled} onClick={onClick}>
              Submit
            </button>
          )}
        </div>
      </StyledForm>
    )
  }
}

export default BasicInfo
